<template>
  <div class="sales-management">
    <div class="header">
      <div class="select">
        <mk-select
          v-model="activeIndex"
          class="select-item"
          width="120"
          placeholder="认证状态"
        >
          <mk-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <div class="select-item">
          <mk-date-picker
            v-model="lastSignInTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="最后签到时间"
          />
          <mk-select
            v-model="afterIndex"
            width="95"
            placeholder="之前"
          >
            <mk-option
              v-for="(item,index) in afterOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </mk-option>
          </mk-select>
        </div>

        <mk-input
          v-model="title"
          class="select-item"
          width="180"
          placeholder="搜索姓名或号码"
        >
          <div
            slot="suffix"
            class="el-input__icon"
          >
            <i
              class="el-icon-search"
              @click="search"
            />
          </div>
        </mk-input>
        <div class="btn-group">
          <mk-button-biz
            class="search-btn"
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz
            width="64px"
            class="reset-btn"
            @click="reset"
          >
            重置
          </mk-button-biz>
        </div>
      </div>
      <div>
        <mk-button-biz
          class="new-add-btn"
          type="primary"
          icon="el-icon-plus"
          @click="addSale"
        >
          新增
        </mk-button-biz>
        <mk-button-biz
          class="export-btn"
          type="primary"
          @click="exportXls"
        >
          批量导入
        </mk-button-biz>
      </div>
    </div>
    <div class="attestation-info">
      已认证人数：{{ attestation.verifiedCount }}/<span class="total">{{ attestation.total }}</span>
    </div>
    <div class="list">
      <mk-table
        :data="list"
        height="100%"
      >
        <mk-table-column
          prop="name"
          label="姓名"
          min-width="160"
        />
        <mk-table-column
          prop="telephone"
          label="电话"
          min-width="110"
        />
        <mk-table-column
          prop="createTime"
          label="添加日期"
          min-width="160"
        />
        <mk-table-column
          label="认证状态"
          min-width="100"
        >
          <template v-slot="scope">
            {{ scope.row.verified ? '已认证' : '未认证' }}
          </template>
        </mk-table-column>
        <mk-table-column
          label="关联微信"
          min-width="160"
          show-overflow-tooltip
        >
          <template v-slot="scope">
            <div class="wx-info">
              <img
                v-if="scope.row.avatarUrl"
                :src="scope.row.avatarUrl"
              >
              <span
                v-if="scope.row.nickName"
                class="ellipsis"
              >{{ scope.row.nickName }}</span>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          prop="verifyCode"
          label="认证码"
          min-width="100"
        />
        <mk-table-column
          prop="lastSignInTime"
          label="最后签到时间"
          min-width="160"
        />
        <mk-table-column
          label="操作"
          width="180"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              @click="edit(scope.row)"
            >
              编辑
            </mk-button-biz>
            <mk-button-biz
              v-if="scope.row.verified"
              type="text"
              @click="cnacelRelation(scope.row)"
            >
              取消微信关联
            </mk-button-biz>
            <mk-button-biz
              type="text"
              @click="remove(scope.row)"
            >
              移除
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>

    <div class="handle-page">
      <!-- <div class="total-info">
        共{{ total }}条
      </div> -->
      <div class="page-info">
        <mk-pagination
          class="pagination"
          :current-page.sync="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </mk-pagination>
        <!-- <span class="page-tip">10条/页</span>
        <div class="jump">
          跳至
          <input
            v-model="nowPage"
            type="number"
            @keyup.enter="updatePage"
          />
          页
        </div> -->
      </div>
    </div>
    <sale-info
      v-if="visible"
      :init-data="saleInfo"
      :edit-id="editId"
      :type="editStatus ? 'edit' : 'add'"
      @cancel="cancel"
      @success="success"
    ></sale-info>
    <export-info
      v-if="exportVisible"
      @cancel="exportCancel"
      @success="exportSuccess"
    ></export-info>
  </div>
</template>
<script>
import saleInfo from '../components/sale-info.vue'
import exportInfo from '../components/export.vue'
import { BIZAPIS } from '../../../api'
export default {
  components: {
    saleInfo,
    exportInfo
  },
  data () {
    return {
      activeIndex: '',
      options: [
        {
          label: '未认证',
          value: 1
        },
        {
          label: '已认证',
          value: 2
        }
      ],
      afterIndex: 0,
      afterOptions: [
        {
          label: '之前',
          value: 0
        },
        {
          label: '之后',
          value: 1
        }
      ],
      title: '',
      attestation: {
        verifiedCount: 0, // 已认证
        total: 0 // 总人数
      },
      list: [], // 列表数据
      page: 1, // 列表页数
      nowPage: 1,
      total: 0, // 列表总数
      visible: false,
      exportVisible: false,
      editStatus: false,
      saleInfo: {},
      editId: '',
      beforeOrAfter: false,
      lastSignInTime: ''
    }
  },
  created () {
    // 销售
    this.getList()
    this.getStatistic()
  },
  methods: {
    updatePage (e) {
      if (Number(this.nowPage) < 1) {
        this.nowPage = 1
        this.page = 1
      } else {
        if (Math.ceil(this.total / 10) <= Number(this.nowPage)) {
          this.nowPage = Math.ceil(this.total / 10)
        }
        this.page = Number(this.nowPage)
      }
      this.getList()
      this.getStatistic()
    },
    handleCurrentChange (e) {
      this.nowPage = e
      this.page = e
      this.getList()
      this.getStatistic()
    },
    edit (data) {
      // 编辑
      this.editStatus = true
      this.visible = true
      this.editId = data._id
      this.saleInfo = {
        name: data.name,
        telephone: data.telephone,
        verifyCode: data.verifyCode
      }
    },
    success () {
      this.visible = false
      this.getList()
      this.getStatistic()
    },
    remove (data) {
      // 移除
      this.$confirm('移除后不可恢复，是否确认操作？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      })
        .then(() => {
          this.removeSale(data._id)
        })
        .catch(() => {})
    },
    async removeSale (id) {
      const res = await BIZAPIS.SalesApi.yqfSalesManageRemoveGet({
        _id: id
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '移除成功',
          showClose: true
        })
        this.getList()
        this.getStatistic()
      }
    },
    cnacelRelation (data) {
      // 取消关联
      this.$confirm('取消微信关联后，该微信号不能再领取任务，是否确认操作？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'none'
      })
        .then(() => {
          this.cancelWxRelation(data._id)
        })
        .catch(() => {})
    },
    async cancelWxRelation (id) {
      const res = await BIZAPIS.SalesApi.yqfSalesManageUnbindGet({
        _id: id
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '解绑成功',
          showClose: true
        })
        this.page = 1
        this.getList()
        this.getStatistic()
      }
    },
    search () {
      this.page = 1
      this.nowPage = 1
      this.getList()
      this.getStatistic()
    },
    reset () {
      this.activeIndex = ''
      this.title = ''
      this.afterIndex = 0
      this.lastSignInTime = ''
    },
    async getList () {
      let metas = {
        page: this.page,
        verified: false
      }
      if (this.title) {
        if (Number(this.title) >= 0) {
          metas['telephone'] = this.title
        } else {
          metas['name'] = this.title
        }
      }
      if (this.activeIndex === '') {
        delete metas['verified']
      } else if (this.activeIndex === 1) {
        metas['verified'] = false
      } else {
        metas['verified'] = true
      }
      if (this.lastSignInTime) {
        metas['lastSignInTime'] = this.lastSignInTime
        let beforeOrAfter = false
        this.afterIndex === 0 ? (beforeOrAfter = false) : (beforeOrAfter = true)
        metas['beforeOrAfter'] = beforeOrAfter
      } else {
        delete metas['lastSignInTime']
      }
      const res = await BIZAPIS.SalesApi.yqfSalesManageListPost(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    async getStatistic () {
      const res = await BIZAPIS.SalesApi.yqfSalesManageStatisticGet({})
      if (res.success) {
        this.attestation = {
          verifiedCount: res.data.verifiedCount,
          total: res.data.total
        }
      }
    },
    addSale () {
      this.editStatus = false
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    exportCancel () {
      this.exportVisible = false
    },
    exportXls () {
      this.exportVisible = true
    },
    exportSuccess () {
      this.getList()
      this.getStatistic()
    }
  }
}
</script>
<style lang="scss" scoped>
.sales-management {
  display: flex;
  flex-direction: column;
  height: 100%;
  // min-width: 1000px;

  /deep/.el-date-editor--datetime {
    width: 200px;
    height: 32px;

    .el-input__inner {
      width: 200px;
      height: 32px;
    }
  }

  /deep/ .el-input__prefix {
    .el-icon-date {
      line-height: 32px;
    }
  }

  /deep/ .el-input__icon {
    line-height: 32px;
  }

  /deep/ .new-btn {
    padding: 0 14px !important;
    border-radius: 4px;

    .el-icon-search {
      font-size: 14px;
    }

    span {
      font-size: 13px;
      margin-left: 4px;
    }
  }

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      display: flex;

      .select-item {
        margin-right: 10px;
      }

      /deep/ .search-btn {
        padding: 0 14px !important;
        border-radius: 4px;

        .el-icon-search {
          font-size: 14px;
        }

        span {
          font-size: 13px;
          margin-left: 4px;
        }
      }

      /deep/ .reset-btn {
        span {
          font-size: 13px;
        }
      }
    }

    .new-add-btn {
      margin-right: 10px;
    }

    /deep/ .new-add-btn {
      padding: 0 8px !important;
    }

    /deep/ .export-btn {
      padding: 0 11px !important;
    }
  }

  .attestation-info {
    margin: 24px 0 16px 20px;
    font-size: 13px;
    color: #262626;
    font-weight: 500;
    flex-shrink: 0;
    // .total {
    //   color: #bfbfbf;
    // }
  }

  .list {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    overflow: auto;

    .wx-info {
      display: flex;
      align-items: center;

      img {
        flex: none;
        display: block;
        width: 26px;
        height: 26px;
        border-radius: 2px;
      }

      span {
        flex: 1;
        color: #595959;
        font-size: 13px;
        margin-left: 12px;
      }
    }
  }

  .handle-page {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 0 28px 0;

    .total-info {
      font-size: 13px;
      color: #6d7278;
      margin-left: 10px;
    }

    .page-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      // /deep/ .pagination {
      //   font-size: 13px;
      //   display: flex;
      //   align-items: center;
      //   margin-top: 0;

      //   .btn-prev {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-right: 6px solid #595959;

      //     .el-icon-arrow-left {
      //       display: none;
      //     }
      //   }

      //   .btn-prev:disabled {
      //     border-right: 6px solid #bfbfbf;
      //   }

      //   .btn-next {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-left: 6px solid #595959;

      //     .el-icon-arrow-right {
      //       display: none;
      //     }
      //   }

      //   .btn-next:disabled {
      //     border-left: 6px solid #bfbfbf;
      //   }

      //   .el-pager {
      //     margin: 0 8px;

      //     li {
      //       min-width: 30px;
      //       height: 24px;
      //       line-height: 24px;
      //     }
      //   }
      // }

      .page-tip {
        font-size: 14px;
        color: #595959;
        margin-left: -16px;
      }

      .jump {
        font-size: 13px;
        color: #595959;
        margin-left: 88px;

        input {
          width: 58px;
          height: 24px;
          padding: 0 12px;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
